export enum GetTransactionOrTicketFilter {
  TICKETS_AND_TRANSACTIONS,
  TICKETS,
  INCOME,
  EXPENSE,
  ALL_TRANSACTIONS,
}
